import React, { useState, useEffect } from "react";
import {
  Loader,
  Table,
  Icon,
  Confirm,
  Button,
  Form,
  Modal,
  Header,
  Label,
  GridColumn,
  Grid,
  Segment,
  Tab,
  Popup,
} from "semantic-ui-react";
import { size, map } from "lodash";
import { EnvironmentalObjetivesform, Form as Form1 } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { EnvironmentalObjetivesFormItem } from "../EnvironmentalObjetivesFormItem";
import {
  hasPermission,
  isAdmin,
  isMaster,
} from "../../../../utils/checkPermission";
import "./ListEnvironmentalObjetivesForms.scss";
import { formatDateView } from "../../../../utils/formatDate";
import { EnvironmentalObjetivesForm } from "../EnvironmentalObjetivesForm";
import { PERIODS } from "../../../../utils";
import { BasicModal, ConfirmModal } from "../../../Shared";
import { environmentalObjetivesCodes } from "../../../../utils/dataAndFormulas/environmentalObjetivesForms";
import { useLanguage } from "../../../../contexts";
import iconSocial    from "../../../../assets/svg/Capa 1.svg";
import iconEnergia   from "../../../../assets/svg/Capa 4.svg";
import iconVehiculos from "../../../../assets/svg/Capa 5.svg";
import iconAgua      from "../../../../assets/svg/Capa 6.svg";
import iconEfluentes from "../../../../assets/svg/Rectangle 184.svg";
import iconResiduos  from "../../../../assets/svg/Group.svg";
const _ = require("lodash");

const environmentalObjetivesFormController = new EnvironmentalObjetivesform();
const formController = new Form1();

export function ListEnvironmentalObjetivesForms(props) {
  const {
    reload,
    onReload,
    siteSelected,
    yearSelected,
    setYearSelected,
    configFormData,
    setReload,
    onObjectiveCreated,
  } = props;
  const [forms, setForms] = useState([]);
  const [page, setPage] = useState(1);
  // const [Role, setRole] = useState(null);
  const {
    user: { role, site },
    accessToken,
  } = useAuth();

  const { language, translations } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  useEffect(() => {
    (async () => {
      if (yearSelected !== "" && siteSelected !== undefined)
        try {
          const response =
            await environmentalObjetivesFormController.getEnvironmentalObjetivesFormsBySiteAndYear(
              accessToken,
              siteSelected,
              yearSelected
            );

          if (response.code === 200 && response.objetives) {
            setForms(response.objetives);
          } else {
            setForms([]);
          }
        } catch (error) {
          console.error(error);
          setForms([]);
        }
    })();
  }, [yearSelected, siteSelected, reload]);

  const changePage = (_, data) => {
    setPage(data.activePage);
  };

  if (!forms) return <Loader active inline="centered" />;
  // if (size(productionforms) === 0) return "No hay ningun formulario de produccón";

  return (
    <div className="list-EnvironmentalObjetives-forms">
      <TablePeriods
        data={forms}
        onReload={onReload}
        accessToken={accessToken}
        year={yearSelected}
        onYearChange={setYearSelected}
        site={siteSelected}
        t={t}
        configFormData={configFormData}
        language={language}
        setReload={setReload}
        onObjectiveCreated={onObjectiveCreated}
      />
    </div>
  );
}

function TablePeriods(props) {
  const { data, onReload, accessToken, year, site, t, language, setReload, onObjectiveCreated } =
    props;

  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [modalContent, setModalContent] = useState("");
  const [dataDeleted, setDataDelete] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);

  const [rows, setRows] = useState([]);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  useEffect(() => {
    (async () => {
      if (data) {
        setRows(data);
      } else {
        setRows([]);
      }
    })();
  }, [data]);

  const openUpdateEnvironmentalObjetivesForm = (form) => {
    setTitleModal(t("edit_environmentalObjetive_form"));
    setModalContent(
      <EnvironmentalObjetivesForm
        onClose={onOpenCloseModal}
        onReload={onReload}
        objetivesForm={form}
        siteSelected={site}
        sumImpact={getImpactByAspect(form.aspect)}
      />
    );
    setShowModal(true);
  };

  const openNewEffluentForm = (aspect) => {
    setTitleModal(t("new_environmentalObjetive_form"));
    setModalContent(
      <EnvironmentalObjetivesForm
        onClose={onOpenCloseModal}
        onReload={onReload}
        year={year}
        siteSelected={site}
        aspect={aspect}
          sumImpact={getImpactByAspect(aspect)}
        onCreated={onObjectiveCreated}
      />
    );
    setShowModal(true);
  };

  const handleDeleteClick = (id) => {
    setDataDelete(id);
    onOpenCloseConfirm();
  };

  const onDelete = async () => {
    try {
      await environmentalObjetivesFormController.deleteEnvironmentalObjetivesForm(
        accessToken,
        dataDeleted
      );
      setDataDelete(null);
      onOpenCloseConfirm();
      onReload();
    } catch (error) {
      console.error(error);
    }
  };

  const [view, setView] = useState("tabs"); // "tabs" o "table"
  const [activeAspect, setActiveAspect] = useState("effluent");

  const energyData = data.filter((item) => item.aspect === "energy");
  const waterData = data.filter((item) => item.aspect === "water");
  const wasteData = data.filter((item) => item.aspect === "waste");
  const effluentsData = data.filter((item) => item.aspect === "effluent");
  const fuelsData = data.filter((item) => item.aspect === "fuels");
  const socialData = data.filter((item) => item.aspect === "social");

  const aspectTabs = [
    { key: "effluent", label: t("effluent"), icon: iconEfluentes, data: effluentsData },
    { key: "social",   label: t("social"),   icon: iconSocial,    data: socialData },
    { key: "energy",   label: t("energy"),   icon: iconEnergia,   data: energyData },
    { key: "fuels",    label: t("fuels"),    icon: iconVehiculos, data: fuelsData },
    { key: "water",    label: t("water"),    icon: iconAgua,      data: waterData },
    { key: "waste",    label: t("waste"),    icon: iconResiduos,  data: wasteData },
  ];


 function getImpactByAspect(aspect) {
  // Filtramos los items por el aspecto
  const filteredData = data.filter(item => item.aspect === aspect);
  // Sumamos los impactos
  const totalImpact = filteredData.reduce((sum, item) => sum + item.impact, 0);
  return totalImpact;
}

  const panes = [
    {
      menuItem: t("effluent"),
      render: () => (
        <Tab.Pane>
          {renderTable(
            effluentsData,
            t,
            "effluent",
            openNewEffluentForm,
            openUpdateEnvironmentalObjetivesForm,
            handleDeleteClick,
            accionOptions
          )}
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("energy"),
      render: () => (
        <Tab.Pane>
          {renderTable(
            energyData,
            t,
            "energy",
            openNewEffluentForm,
            openUpdateEnvironmentalObjetivesForm,
            handleDeleteClick,
            accionOptions
          )}
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("water"),
      render: () => (
        <Tab.Pane>
          {renderTable(
            waterData,
            t,
            "water",
            openNewEffluentForm,
            openUpdateEnvironmentalObjetivesForm,
            handleDeleteClick,
            accionOptions
          )}
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("waste"),
      render: () => (
        <Tab.Pane>
          {renderTable(
            wasteData,
            t,
            "waste",
            openNewEffluentForm,
            openUpdateEnvironmentalObjetivesForm,
            handleDeleteClick,
            accionOptions
          )}
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("fuels"),
      render: () => (
        <Tab.Pane>
          {renderTable(
            fuelsData,
            t,
            "fuels",
            openNewEffluentForm,
            openUpdateEnvironmentalObjetivesForm,
            handleDeleteClick,
            accionOptions
          )}
        </Tab.Pane>
      ),
    },
  ];

  const accionOptions = [
    { key: "reduce", text: t("reduce"), value: "reduce" },
    { key: "increase", text: t("increase"), value: "increase" },
  ];

  return (
    <div>
      <Grid>
        <Grid.Row>
          <Grid.Column textAlign="right">
         
            <Button.Group className="obj-view-toggle">
              <Popup
                content="Vista por aspectos"
                trigger={
                  <Button
                    color={view === "tabs" ? "blue" : null}
                    onClick={() => setView("tabs")}
                  >
                    <Icon name="clone outline" />
                  </Button>
                }
                on="hover"
                position="top center"
                inverted
              />

              <Popup
                content="Vista completa"
                trigger={
                  <Button
                    color={view === "table" ? "blue" : null}
                    onClick={() => setView("table")}
                  >
                    <Icon name="table" />
                  </Button>
                }
                on="hover"
                position="top center"
                inverted
              />
            </Button.Group>
          </Grid.Column>
        </Grid.Row>
      </Grid>

      {view === "tabs" ? (
        <div className="obj-tabs-view">
          <div className="obj-tabs-header">
            <div className="obj-tabs-list">
              {aspectTabs.map((tab) => (
                <button
                  key={tab.key}
                  className={`obj-tab-pill${activeAspect === tab.key ? " active" : ""}`}
                  onClick={() => setActiveAspect(tab.key)}
                >
                  <img src={tab.icon} alt={tab.label} className="menu-sub-icon" /> {tab.label}
                </button>
              ))}
            </div>
            <div className="obj-tabs-actions">
              <button className="obj-add-btn" onClick={() => openNewEffluentForm(activeAspect)}>+</button>
            </div>
          </div>
          {renderTable(
            aspectTabs.find((tab) => tab.key === activeAspect)?.data || [],
            t,
            activeAspect,
            openNewEffluentForm,
            openUpdateEnvironmentalObjetivesForm,
            handleDeleteClick,
            accionOptions
          )}
        </div>
      ) : (
        <div className="obj-full-view">
          {renderFullSection(t("effluent"), effluentsData, t, "effluent", openNewEffluentForm, openUpdateEnvironmentalObjetivesForm, handleDeleteClick, accionOptions, iconEfluentes)}
          {renderFullSection(t("social"), socialData, t, "social", openNewEffluentForm, openUpdateEnvironmentalObjetivesForm, handleDeleteClick, accionOptions, iconSocial)}
          {renderFullSection(t("energy"), energyData, t, "energy", openNewEffluentForm, openUpdateEnvironmentalObjetivesForm, handleDeleteClick, accionOptions, iconEnergia)}
          {renderFullSection(t("fuels"), fuelsData, t, "fuels", openNewEffluentForm, openUpdateEnvironmentalObjetivesForm, handleDeleteClick, accionOptions, iconVehiculos)}
          {renderFullSection(t("water"), waterData, t, "water", openNewEffluentForm, openUpdateEnvironmentalObjetivesForm, handleDeleteClick, accionOptions, iconAgua)}
          {renderFullSection(t("waste"), wasteData, t, "waste", openNewEffluentForm, openUpdateEnvironmentalObjetivesForm, handleDeleteClick, accionOptions, iconResiduos)}
        </div>
      )}

      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        size={"fullscreen"}
      >
        {modalContent}
      </BasicModal>

      <ConfirmModal
        open={showConfirm}
        title={t("delete")}
        content={t("delete_EnvironmentalObjetives_form_with_date")}
        onConfirm={onDelete}
        onCancel={onOpenCloseConfirm}
        danger
      />
    </div>
  );
}

const renderTable = (
  data,
  t,
  aspect,
  openNewEffluentForm,
  openUpdateEnvironmentalObjetivesForm,
  onDelete,
  accionOptions
) => (
  <Table className="obj-table" compact size="small">
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>{t("aspect")}</Table.HeaderCell>
        <Table.HeaderCell>{t("year")}</Table.HeaderCell>
        <Table.HeaderCell>{t("action")}</Table.HeaderCell>
        <Table.HeaderCell>{t("source")}</Table.HeaderCell>
        <Table.HeaderCell>{t("reductionTons")}</Table.HeaderCell>
        <Table.HeaderCell>{t("start")}</Table.HeaderCell>
        <Table.HeaderCell>{t("end")}</Table.HeaderCell>
        <Table.HeaderCell>{t("measure")}</Table.HeaderCell>
        <Table.HeaderCell>{t("impact")}</Table.HeaderCell>
        <Table.HeaderCell>{t("investment")}</Table.HeaderCell>
        <Table.HeaderCell></Table.HeaderCell>
      </Table.Row>
    </Table.Header>
    <Table.Body>
      {data?.length > 0 ? (
        data.map((row, idx) => (
          <Table.Row key={idx}>
            <Table.Cell>{t(row.aspect)}</Table.Cell>
            <Table.Cell>{row.year}</Table.Cell>
            <Table.Cell>{accionOptions.find((opt) => opt.value === row.action)?.text || row.action}</Table.Cell>
            <Table.Cell>{row.source}</Table.Cell>
            <Table.Cell>{row.reductionTons}</Table.Cell>
            <Table.Cell>{formatDateView(row.periodStart)}</Table.Cell>
            <Table.Cell>{formatDateView(row.periodEnd)}</Table.Cell>
            <Table.Cell>{row.measure}</Table.Cell>
            <Table.Cell>{row.impact}</Table.Cell>
            <Table.Cell>{row.investment}</Table.Cell>
            <Table.Cell>
              <Button primary icon="edit" size="tiny" className="obj-action-btn" onClick={() => openUpdateEnvironmentalObjetivesForm(row)} />
              <Button color="red" icon="trash" size="tiny" className="obj-action-btn" onClick={() => onDelete(row._id)} />
            </Table.Cell>
          </Table.Row>
        ))
      ) : (
        <Table.Row>
          <Table.Cell colSpan="11" textAlign="center">
            No hay datos disponibles
          </Table.Cell>
        </Table.Row>
      )}
    </Table.Body>
  </Table>
);

const renderFullSection = (
  title,
  data,
  t,
  aspect,
  openNewEffluentForm,
  openUpdateEnvironmentalObjetivesForm,
  onDelete,
  accionOptions,
  icon,
  extraControl = null
) => (
  <div className="obj-section" key={aspect}>
    <div className="obj-section-header">
      <span className="obj-section-pill">
        <img src={icon} alt={title} className="menu-sub-icon" /> {title}
      </span>
      <button className="obj-add-btn" onClick={() => openNewEffluentForm(aspect)}>+</button>
      {extraControl}
    </div>
    <Table className="obj-table" compact size="small">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>{t("aspect")}</Table.HeaderCell>
          <Table.HeaderCell>{t("year")}</Table.HeaderCell>
          <Table.HeaderCell>{t("action")}</Table.HeaderCell>
          <Table.HeaderCell>{t("source")}</Table.HeaderCell>
          <Table.HeaderCell>{t("reductionTons")}</Table.HeaderCell>
          <Table.HeaderCell>{t("start")}</Table.HeaderCell>
          <Table.HeaderCell>{t("end")}</Table.HeaderCell>
          <Table.HeaderCell>{t("measure")}</Table.HeaderCell>
          <Table.HeaderCell>{t("impact")}</Table.HeaderCell>
          <Table.HeaderCell>{t("investment")}</Table.HeaderCell>
          <Table.HeaderCell></Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {data?.length > 0 ? (
          data.map((row, idx) => (
            <Table.Row key={idx}>
              <Table.Cell>{t(row.aspect)}</Table.Cell>
              <Table.Cell>{row.year}</Table.Cell>
              <Table.Cell>
                {accionOptions.find((opt) => opt.value === row.action)?.text || row.action}
              </Table.Cell>
              <Table.Cell>{row.source}</Table.Cell>
              <Table.Cell>{row.reductionTons}</Table.Cell>
              <Table.Cell>{formatDateView(row.periodStart)}</Table.Cell>
              <Table.Cell>{formatDateView(row.periodEnd)}</Table.Cell>
              <Table.Cell>{row.measure}</Table.Cell>
              <Table.Cell>{row.impact}</Table.Cell>
              <Table.Cell>{row.investment}</Table.Cell>
              <Table.Cell>
                <Button primary icon="edit" size="tiny" className="obj-action-btn" onClick={() => openUpdateEnvironmentalObjetivesForm(row)} />
                <Button color="red" icon="trash" size="tiny" className="obj-action-btn" onClick={() => onDelete(row._id)} />
              </Table.Cell>
            </Table.Row>
          ))
        ) : (
          <Table.Row>
            <Table.Cell colSpan="11" textAlign="center">
              No hay datos disponibles
            </Table.Cell>
          </Table.Row>
        )}
      </Table.Body>
    </Table>
  </div>
);

const renderSection = (
  title,
  data,
  t,
  aspect,
  openNewEffluentForm,
  openUpdateEnvironmentalObjetivesForm,
  onDelete,
  accionOptions
) => (
  <>
    {/* Fila con el título de la sección */}
    <Table.Row>
      <Table.Cell colSpan="11">
        <Label color="blue" ribbon>
          {title}
        </Label>
      </Table.Cell>
    </Table.Row>

    {/* Filas de datos */}
    {data?.length > 0 ? (
      data.map((row, idx) => (
        <Table.Row key={idx}>
          <Table.Cell>{t(row.aspect)}</Table.Cell>
          <Table.Cell>{row.year}</Table.Cell>
          <Table.Cell>
            {accionOptions.find((opt) => opt.value === row.action)?.text ||
              row.action}
          </Table.Cell>
          <Table.Cell>{row.source}</Table.Cell>
          <Table.Cell>{row.reductionTons}</Table.Cell>
          <Table.Cell>{formatDateView(row.periodStart)}</Table.Cell>
          <Table.Cell>{formatDateView(row.periodEnd)}</Table.Cell>
          <Table.Cell>{row.measure}</Table.Cell>
          <Table.Cell>{row.impact}</Table.Cell>
          <Table.Cell>{row.investment}</Table.Cell>
          <Table.Cell>
            <Popup
              content={t("edit")}
              trigger={
                <Button
                  icon="edit"
                  size="tiny"
                  onClick={() => openUpdateEnvironmentalObjetivesForm(row)}
                />
              }
              on="hover"
              position="top center"
              inverted
            />
            <Popup
              content={t("delete")}
              trigger={
                <Button
                  icon="trash"
                  size="tiny"
                  color="red"
                  onClick={() => onDelete(row._id)}
                />
              }
              on="hover"
              position="top center"
              inverted
            />
          </Table.Cell>
        </Table.Row>
      ))
    ) : (
      <Table.Row>
        <Table.Cell colSpan="11" textAlign="center">
          No hay datos disponibles
        </Table.Cell>
      </Table.Row>
    )}

    {/* Fila con botón + alineado a la derecha */}
    <Table.Row>
      <Table.Cell colSpan="11" textAlign="right">
        <Popup
          content={t("add")}
          trigger={
            <Button
              icon="plus"
              primary
              onClick={() => openNewEffluentForm(aspect)}
              content={t("new")}
            />
          }
          on="hover"
          position="top center"
          inverted
        />
      </Table.Cell>
    </Table.Row>
  </>
);
